// extracted by mini-css-extract-plugin
module.exports = {"editableLink":"style_editableLink__39GXq","selector":"style_selector__3xYa6"};